import React from "react";
import APP_VERSION from "../version";
import WHATS_NEW_CONTENT from "../data/whatsNewContent";
import { getMajorMinor } from "../utils/versionUtils";
import { useTranslation } from "react-i18next";
import { useServerVersion } from "../utils/serverVersion";

const linkStyle = {
  background: "none",
  border: "none",
  padding: 0,
  font: "inherit",
  color: "inherit",
  cursor: "pointer",
  textDecoration: "underline dotted",
};

function Footer({ onVersionClick, onGdprClick }) {
  const { t } = useTranslation();
  const serverVersion = useServerVersion();
  const majorMinor = getMajorMinor(APP_VERSION);
  const hasContent = !!WHATS_NEW_CONTENT[majorMinor];

  return (
    <footer
      style={{
        width: "100%",
        padding: "6px 12px",
        fontSize: "12px",
        textAlign: "center",
        borderTop: "1px solid var(--bs-border-color)",
        background: "var(--bs-body-bg)",
      }}
    >
      <span>
        {hasContent ? (
          <button onClick={onVersionClick} style={linkStyle}>
            Version {APP_VERSION}
          </button>
        ) : (
          <span>Version {APP_VERSION}</span>
        )}
        {serverVersion && <span id="server-version" className="text-muted"> (API {serverVersion})</span>}
        {" · "}
        <button onClick={onGdprClick} style={linkStyle}>
          {t("gdpr_link")}
        </button>
        {" "}© ezentry 2026
      </span>
    </footer>
  );
}

export default Footer;
